var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        [
          !_vm.readonly
            ? _c(
                "b-col",
                { staticClass: "form-group", attrs: { sm: "6" } },
                [
                  _c("form-write-group-label-input", {
                    attrs: {
                      isMandatory: "",
                      inputLabel: _vm.$t("common.alerts.name"),
                      placeholderValue: _vm.$t("common.alerts.name"),
                      autocomplete: "off",
                    },
                    model: {
                      value: _vm.Name,
                      callback: function ($$v) {
                        _vm.Name = $$v
                      },
                      expression: "Name",
                    },
                  }),
                ],
                1
              )
            : _c(
                "b-col",
                { staticClass: "form-group", attrs: { sm: "6" } },
                [
                  _c("form-read-group-label-input", {
                    attrs: {
                      isMandatory: "",
                      inputLabel: _vm.$t("common.alerts.name"),
                      inputValue: _vm.Name,
                    },
                  }),
                ],
                1
              ),
          _vm._v(" "),
          !_vm.readonly
            ? _c("b-col", { staticClass: "form-group", attrs: { sm: "6" } }, [
                _c("label", { attrs: { for: "metrickey" } }, [
                  _vm._v(
                    "\n        " + _vm._s(_vm.$t("common.alerts.metrics_key"))
                  ),
                  _c("span", { staticClass: "color-red" }, [_vm._v(" * ")]),
                ]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.IdMetricsKey,
                        expression: "IdMetricsKey",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: {
                      id: "metrickey",
                      "aria-required": "true",
                      autocomplete: "off",
                    },
                    on: {
                      change: [
                        function ($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function (o) {
                              return o.selected
                            })
                            .map(function (o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.IdMetricsKey = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        },
                        _vm.updateThresholdUnitList,
                      ],
                    },
                  },
                  [
                    _c(
                      "option",
                      {
                        attrs: { selected: "", disabled: "" },
                        domProps: { value: undefined },
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("common.alerts.metrics_key_select"))
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.metricsKeyList, function (metricsKey) {
                      return _c(
                        "option",
                        {
                          key: metricsKey.id,
                          domProps: { value: metricsKey.id },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.$t(
                                  "common.monitoring.key." + metricsKey.text
                                )
                              ) +
                              "\n        "
                          ),
                        ]
                      )
                    }),
                  ],
                  2
                ),
              ])
            : _c(
                "b-col",
                { staticClass: "form-group", attrs: { sm: "6" } },
                [
                  _c("form-read-group-label-input", {
                    attrs: {
                      isMandatory: "",
                      inputLabel: _vm.$t("common.alerts.metrics_key"),
                      inputValue: _vm.$t(
                        "common.monitoring.key." + _vm.MetricsKey
                      ),
                    },
                  }),
                ],
                1
              ),
          _vm._v(" "),
          !_vm.readonly
            ? _c("b-col", { staticClass: "form-group", attrs: { sm: "6" } }, [
                _c("label", { attrs: { for: "thresholdUnit" } }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("common.alerts.threshold_unit"))
                  ),
                  _c("span", { staticClass: "color-red" }, [_vm._v(" * ")]),
                ]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.IdThresholdUnit,
                        expression: "IdThresholdUnit",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: {
                      id: "thresholdUnit",
                      "aria-required": "true",
                      autocomplete: "off",
                    },
                    on: {
                      change: function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.IdThresholdUnit = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                    },
                  },
                  [
                    _c(
                      "option",
                      {
                        attrs: { selected: "", disabled: "" },
                        domProps: { value: undefined },
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("common.alerts.threshold_unit_select"))
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.thresholdUnitList, function (thresholdUnit) {
                      return _c(
                        "option",
                        {
                          key: thresholdUnit.id,
                          domProps: { value: thresholdUnit.id },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(thresholdUnit.text) +
                              "\n        "
                          ),
                        ]
                      )
                    }),
                  ],
                  2
                ),
              ])
            : _c(
                "b-col",
                { staticClass: "form-group", attrs: { sm: "6" } },
                [
                  _c("form-read-group-label-input", {
                    attrs: {
                      isMandatory: "",
                      inputLabel: _vm.$t("common.alerts.threshold_unit"),
                      inputValue: _vm.ThresholdUnit,
                    },
                  }),
                ],
                1
              ),
          _vm._v(" "),
          !_vm.readonly
            ? _c(
                "b-col",
                { staticClass: "form-group", attrs: { sm: "6" } },
                [
                  _c("form-write-group-label-input", {
                    attrs: {
                      inputType: "number",
                      isMandatory: "",
                      inputLabel: _vm.$t("common.alerts.threshold_low"),
                      placeholderValue: _vm.$t("common.alerts.threshold_low"),
                      autocomplete: "off",
                    },
                    model: {
                      value: _vm.ThresholdLow,
                      callback: function ($$v) {
                        _vm.ThresholdLow = $$v
                      },
                      expression: "ThresholdLow",
                    },
                  }),
                ],
                1
              )
            : _c(
                "b-col",
                { staticClass: "form-group", attrs: { sm: "6" } },
                [
                  _c("form-read-group-label-input", {
                    attrs: {
                      isMandatory: "",
                      inputLabel: _vm.$t("common.alerts.threshold_low"),
                      inputValue: _vm.ThresholdLow,
                      inputType: "number",
                    },
                  }),
                ],
                1
              ),
          _vm._v(" "),
          !_vm.readonly
            ? _c(
                "b-col",
                { staticClass: "form-group", attrs: { sm: "6" } },
                [
                  _c("form-write-group-label-input", {
                    attrs: {
                      inputType: "number",
                      isMandatory: "",
                      inputLabel: _vm.$t("common.alerts.threshold_high"),
                      placeholderValue: _vm.$t("common.alerts.threshold_high"),
                      autocomplete: "off",
                    },
                    model: {
                      value: _vm.ThresholdHigh,
                      callback: function ($$v) {
                        _vm.ThresholdHigh = $$v
                      },
                      expression: "ThresholdHigh",
                    },
                  }),
                ],
                1
              )
            : _c(
                "b-col",
                { staticClass: "form-group", attrs: { sm: "6" } },
                [
                  _c("form-read-group-label-input", {
                    attrs: {
                      isMandatory: "",
                      inputLabel: _vm.$t("common.alerts.threshold_high"),
                      inputValue: _vm.ThresholdHigh,
                      inputType: "number",
                    },
                  }),
                ],
                1
              ),
          _vm._v(" "),
          _vm.readonly
            ? _c(
                "b-col",
                { staticClass: "form-group", attrs: { sm: "6" } },
                [
                  _c("form-read-group-label-input", {
                    attrs: {
                      isMandatory: "",
                      inputLabel: _vm.$t("common.alerts.updated_at"),
                      inputValue: _vm.UpdatedAt,
                    },
                  }),
                ],
                1
              )
            : _vm.EmailGroupName > 0
            ? _c(
                "b-col",
                { staticClass: "form-group", attrs: { sm: "6" } },
                [
                  _c("form-read-group-label-input", {
                    attrs: {
                      inputLabel: _vm.$t("common.email.group_name"),
                      inputValue: Array.isArray(_vm.EmailGroupName)
                        ? _vm.EmailGroupName.join(", ")
                        : _vm.EmailGroupName,
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.readonly
            ? _c(
                "b-col",
                { staticClass: "form-group", attrs: { sm: "6" } },
                [
                  _c("form-write-group-label-input", {
                    attrs: {
                      inputLabel: _vm.$t("common.alerts.description"),
                      placeholderValue: _vm.$t("common.alerts.description"),
                      autocomplete: "off",
                    },
                    model: {
                      value: _vm.Description,
                      callback: function ($$v) {
                        _vm.Description = $$v
                      },
                      expression: "Description",
                    },
                  }),
                ],
                1
              )
            : _vm.Description
            ? _c(
                "b-col",
                { staticClass: "form-group", attrs: { sm: "6" } },
                [
                  _c("form-read-group-label-input", {
                    attrs: {
                      inputLabel: _vm.$t("common.alerts.description"),
                      inputValue: _vm.Description,
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.readonly
            ? _c("b-col", { staticClass: "form-group", attrs: { sm: "6" } }, [
                _c("label", { attrs: { for: "criticality" } }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("common.alerts.criticality_level"))
                  ),
                  _c("span", { staticClass: "color-red" }, [_vm._v(" * ")]),
                ]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.Criticality,
                        expression: "Criticality",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: {
                      id: "criticality",
                      "aria-required": "true",
                      autocomplete: "off",
                    },
                    on: {
                      change: function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.Criticality = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                    },
                  },
                  [
                    _c(
                      "option",
                      {
                        attrs: { selected: "", disabled: "" },
                        domProps: { value: undefined },
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t("common.alerts.criticality_level_select")
                          )
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.criticalityList, function (criticality) {
                      return _c(
                        "option",
                        {
                          key: criticality.id,
                          domProps: { value: criticality.id },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(criticality.label) +
                              "\n        "
                          ),
                        ]
                      )
                    }),
                  ],
                  2
                ),
              ])
            : _c(
                "b-col",
                { staticClass: "form-group", attrs: { sm: "6" } },
                [
                  _c("form-read-group-label-input", {
                    attrs: {
                      isMandatory: "",
                      inputLabel: _vm.$t("common.alerts.criticality_level"),
                      inputValue: _vm.getCriticalityLabel(_vm.Criticality),
                    },
                  }),
                ],
                1
              ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }